function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1{fill:#fff}"));

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M43.67 19.69a5.59 5.59 0 0 0-3.36-3.36 16 16 0 0 0-4.22-.63c-1.14 0-2.76-.08-4.84-.08h-2.5c-2.08 0-3.7 0-4.84.08a16.73 16.73 0 0 0-4.22.63 5.59 5.59 0 0 0-3.36 3.36 16 16 0 0 0-.63 4.22c0 1.14-.07 2.76-.07 4.84v2.5c0 2.08 0 3.7.07 4.84a16.73 16.73 0 0 0 .63 4.22 5.88 5.88 0 0 0 3.36 3.36 16.73 16.73 0 0 0 4.22.63c1.14.05 2.76.07 4.84.07h2.5c2.14 0 3.75 0 4.84-.07a16 16 0 0 0 4.22-.63 5.88 5.88 0 0 0 3.36-3.36 16.73 16.73 0 0 0 .63-4.22c.05-1.14.08-2.76.08-4.84v-2.5c0-2.14 0-3.75-.08-4.84a16 16 0 0 0-.63-4.22zm-5.9 14.8a8.9 8.9 0 0 1-3.28 3.28 8.94 8.94 0 0 1-9 0 8.9 8.9 0 0 1-3.28-3.28 8.94 8.94 0 0 1 0-9 8.9 8.9 0 0 1 3.28-3.28 8.94 8.94 0 0 1 9 0 8.9 8.9 0 0 1 3.28 3.28 8.94 8.94 0 0 1 0 9zm3-12.38a1.88 1.88 0 0 1-1.44.62 2.1 2.1 0 1 1 2.1-2.11 2.43 2.43 0 0 1-.61 1.49z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M30 24.14A5.87 5.87 0 0 0 24.14 30 5.87 5.87 0 0 0 30 35.86 5.87 5.87 0 0 0 35.86 30 5.87 5.87 0 0 0 30 24.14z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  className: "cls-1",
  d: "M56 0H4a4 4 0 0 0-4 4v52a4 4 0 0 0 4 4h52a4 4 0 0 0 4-4V4a4 4 0 0 0-4-4zm-8.62 37.3a15 15 0 0 1-.66 3.87 9.15 9.15 0 0 1-5.55 5.55 15 15 0 0 1-3.87.66q-2.22.12-7.3.12t-7.3-.12a12.68 12.68 0 0 1-3.87-.74 8.4 8.4 0 0 1-3.4-2.07 9.16 9.16 0 0 1-2.15-3.4 15 15 0 0 1-.66-3.87q-.12-2.22-.12-7.3t.12-7.3a15 15 0 0 1 .66-3.87 9.15 9.15 0 0 1 5.55-5.55 15 15 0 0 1 3.87-.66q2.22-.12 7.3-.12t7.3.12a15 15 0 0 1 3.87.66 9.15 9.15 0 0 1 5.55 5.55 15.84 15.84 0 0 1 .7 3.9q.07 2.19.08 7.27t-.12 7.3z"
});

var SvgInstagramWht = function SvgInstagramWht(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 60 60",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInstagramWht, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram_wht.02025911.svg";
export { ForwardRef as ReactComponent };